import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import ContentContainer from 'root/client/components/content-container/content-container';
import SalesLoader from 'root/client/components/sales-loader/sales-loader';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type { DropInStatus as Props } from './drop-in-status.types';

const DropInStatus: React.FunctionComponent<Props> = ({
  information,
  layout,
}) => (
  <SalesLayout {...layout}>
    <div className="drop-in-status">
      <ContentContainer
        width={ContentContainer.widths.Narrow}
        className="drop-in-status__content"
      >
        <div
          className="drop-in-status__processing-wrapper"
          data-testid="status"
        >
          <SalesLoader />
          <Text size={Text.sizes.large}>{information}</Text>
        </div>
      </ContentContainer>
    </div>
  </SalesLayout>
);

export default DropInStatus;
